

const AgreementFilters = ({ filters, onFilterChange }) => {
  const statusOptions = [
    { value: "", label: "All Status" },
    { value: "active", label: "Active" },
    { value: "superseded", label: "Superseded" },
    { value: "revoked", label: "Revoked" },
    { value: "expired", label: "Expired" },
  ]

  const handleFilterChange = (key, value) => {
    onFilterChange({ [key]: value })
  }

  const handleSearchChange = (e) => {
    const value = e.target.value
    clearTimeout(window.searchTimeout)
    window.searchTimeout = setTimeout(() => {
      onFilterChange({ search: value })
    }, 500)
  }

  const clearFilters = () => {
    onFilterChange({
      status: "",
      search: "",
    })
  }

  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="row align-items-end">
          <div className="col-md-4">
            <label className="form-label">Search</label>
            <div className="input-group">
              <span className="input-group-text">
                <i className="fas fa-search"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search by user, document..."
                defaultValue={filters.search}
                onChange={handleSearchChange}
              />
            </div>
          </div>

          <div className="col-md-3">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              value={filters.status}
              onChange={(e) => handleFilterChange("status", e.target.value)}
            >
              {statusOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-2">
            <label className="form-label">Items per page</label>
            <select
              className="form-select"
              value={filters.limit}
              onChange={(e) => handleFilterChange("limit", e.target.value)}
            >
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>

          <div className="col-md-2">
            <button
              type="button"
              className="btn btn-outline-secondary w-100"
              onClick={clearFilters}
              title="Clear Filters"
            >
              Clear
            </button>
          </div>
        </div>

        {/* Active Filters Display */}
        {(filters.status || filters.search) && (
          <div className="mt-3">
            <small className="text-muted">Active filters:</small>
            <div className="d-flex flex-wrap gap-2 mt-1">
              {filters.search && (
                <span className="badge bg-primary">
                  Search: "{filters.search}"
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-1"
                    style={{ fontSize: "0.7em" }}
                    onClick={() => handleFilterChange("search", "")}
                  ></button>
                </span>
              )}
              {filters.status && (
                <span className="badge bg-success">
                  Status: {statusOptions.find((o) => o.value === filters.status)?.label}
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-1"
                    style={{ fontSize: "0.7em" }}
                    onClick={() => handleFilterChange("status", "")}
                  ></button>
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default AgreementFilters